import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isArray } from 'lodash';

import { useModal } from 'Store/modal';
import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';
import { targetDeleteDomainText } from 'Const/target/text';
import deleteTarget from 'Api/target/deleteTarget';

import { useTargetState } from 'View/target/state';

const useDeleteTarget = ({ t }) => {
  const queryClient = useQueryClient();
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();
  const { onResetModal } = useModal();
  const { updateState, filterState } = useTargetState();

  return useMutation({
    mutationFn: async (id) => {
      onShowLoader({ variant: 'loader-primary' });

      return await deleteTarget({ id });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['target', filterState] });

      onOpenToast({
        status: 'success',
        description: t('deleteModal.successText'),
        duration: 5,
        alwaysShow: false,
      });

      updateState({ alertProps: {} });
    },
    onError: (error) => {
      const errorMessage = isArray(error?.response?.data?.errors) ? error?.response?.data?.errors[0]?.message : targetDeleteDomainText?.errorDescription;

      updateState({
        alertProps: {
          isOpen: true,
          type: 'error',
          title: targetDeleteDomainText?.errorTitle,
          description: errorMessage,
          onClose: () => updateState({ alertProps: {} }),
          marginBottom: '12px',
        },
      });
    },
    onSettled: () => {
      onResetLoader();
      onResetModal();
    },
  });
};

export default useDeleteTarget;
